import React from 'react'
import { Images } from 'components'

export default function LogoAnimatedWhite() {
  return <img src={Images.logoAnimatedWhite} alt="" width="220" />
}
